import { useMemo } from 'react';
import { genJsonataAst, type AnyAstParseResult } from '@splunk/dashboard-utils';

export const useJsonataAstParser = (expression: string): AnyAstParseResult => {
    return useMemo(() => genJsonataAst(expression), [expression]);
};
